/**
 * @desc        Private Route
 * @version     2.0.0 (Added AWS Auth. Disabled billing redirect) - 15 Aug 2025 **/

import React, { useMemo, useCallback } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ENVPRE } from 'app-config/index.js'

const PrivateRoute = ({ children, render, ...rest }) => {
    const { isLoggedIn, isLoading, needsToPay } = useSelector(state => ({
        isLoggedIn: Boolean(state?.aws?.data?.signInUserSession?.idToken),
        isLoading: Boolean(state?.aws?.loading),
        needsToPay: Boolean(state?.awsut?.needsToPay && !state?.aws?.isMaster), // review if this is causing any issues. currently seeing it looping customers in /settings
    }))

    const account = useMemo(() => localStorage.getItem(`${ENVPRE}account`), [])
    const accounts = useMemo(() => localStorage.getItem(`${ENVPRE}accounts`), [])

    const renderContent = useCallback(
        (...args) => {
            // Show nothing while loading initial auth state (not during token refresh)
            if (isLoading && !isLoggedIn) {
                return null
            }

            // Redirect to login if not authenticated
            if (!isLoggedIn) {
                return (
                    <Redirect
                        to={{
                            pathname: '/auth/login',
                        }}
                    />
                )
            }

            // Redirect to login if no account data (new user)
            if (!account && !accounts) {
                return (
                    <Redirect
                        to={{
                            pathname: '/auth/login',
                        }}
                    />
                )
            }

            // Render the protected content
            return render ? render(...args) : children
        },
        [isLoading, isLoggedIn, account, accounts, render, children],
    )

    return <Route {...rest} render={renderContent} />
}

export default React.memo(PrivateRoute)

/* eslint eqeqeq: 0 */
// disabled for now
// if (account && account != '*' && needsToPay && rest.location && (rest.location.pathname.indexOf('/settings') < 0 || !rest?.location?.state?.disableTabs)) {
//     return (
//         <Redirect
//             to={{
//                 pathname: `/${account}/settings`,
//                 state: {
//                     tab: "billing",
//                     disableTabs: true
//                 }
//             }}
//         />
//     )
// }
